package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.BookmarkW500RoundedFill: ImageVector
    get() {
        if (_bookmarkW500RoundedFill != null) {
            return _bookmarkW500RoundedFill!!
        }
        _bookmarkW500RoundedFill = Builder(name = "BookmarkW500RoundedFill", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(480.0f, 728.85f)
                lineToRelative(-161.07f, 68.89f)
                quadToRelative(-45.5f, 19.15f, -86.28f, -7.58f)
                quadToRelative(-40.78f, -26.73f, -40.78f, -75.7f)
                verticalLineToRelative(-511.59f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                horizontalLineToRelative(394.26f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(511.59f)
                quadToRelative(0.0f, 48.97f, -40.78f, 75.7f)
                quadToRelative(-40.78f, 26.73f, -86.28f, 7.58f)
                lineTo(480.0f, 728.85f)
                close()
            }
        }
        .build()
        return _bookmarkW500RoundedFill!!
    }

private var _bookmarkW500RoundedFill: ImageVector? = null
